import { render } from "./CreateTable.vue?vue&type=template&id=c02f7ac0&scoped=true&ts=true"
import script from "./CreateTable.ts?vue&type=script&lang=ts"
export * from "./CreateTable.ts?vue&type=script&lang=ts"

import "./CreateTable.scss?vue&type=style&index=0&id=c02f7ac0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02f7ac0"]])

export default __exports__